import { Injectable } from '@angular/core';
import { ApiService, UserService } from '..';

@Injectable()
export class HeThongService {
  APIURL = "api/ExcuteOracle";
  constructor(private apiService: ApiService, private userService: UserService) { }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/hethong.service.ts